
import { defineComponent, PropType } from 'vue'

type KnowledgePromoteMode = 'promote' | 'demote'

export default defineComponent({
  name: 'KnowledgePromoteConfirmModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String as PropType<KnowledgePromoteMode>,
      default: 'promote'
    }
  },
  data() {
    return {
      note: ''
    }
  },
  computed: {
    isDemote(): boolean {
      return this.mode === 'demote'
    },
    copy(): { title: string; action: string; icon: string; prompt: string } {
      return this.isDemote
        ? {
            title: 'Demote from team memory?',
            action: 'Demote from team',
            icon: 'arrow-down-left',
            prompt: 'Why demote?'
          }
        : {
            title: 'Promote to team memory?',
            action: 'Promote to team',
            icon: 'arrow-up-right',
            prompt: 'Why promote?'
          }
    }
  },
  watch: {
    isOpen(open: boolean): void {
      if (!open) this.note = ''
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    confirm(): void {
      this.$emit(this.mode, { note: this.note })
    }
  }
})
